export default __webpack_public_path__ + "static/media/Email.d1395166.svg";